import Link from "next/link";

import { Button } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";
import { AppShell } from "@chef/feature-app-shell";

import { intl } from "./GiftCardErrorState.Intl";

export const GiftCardErrorState = () => {
  return (
    <AppShell title={intl.GIFT_CARD}>
      <AppShell.Meta />

      <AppShell.Header />

      <AppShell.Main grid>
        <div className="flex flex-col col-span-4 p-6 px-8 mx-auto mb-2 md:px-0 xl:col-span-6 xl:col-start-4 md:col-span-4 md:col-start-3">
          <div className="flex flex-col items-center gap-6">
            <h1 className="text-xl text-center text-error">
              <strong>{intl.SOMETHING_WENT_WRONG}</strong>
            </h1>
            <p className="text-center">{intl.AN_ERROR_HAS_OCCURED}</p>
            <div className="flex flex-col w-full gap-4 lg:w-72">
              <Link
                href={BRAND_PATHS.GIFTCARD_PAGE}
                passHref
                className="w-full"
              >
                <Button primary className="w-full">
                  {intl.TRY_AGAIN}
                </Button>
              </Link>
              <Link
                href={BRAND_PATHS.CONTACT_US_PAGE_LOGOUT}
                passHref
                className="w-full"
              >
                <Button outlined className="w-full">
                  {intl.CONCTACT_SUPPORT}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </AppShell.Main>
      <AppShell.Footer />
      <AppShell.TabBar />
    </AppShell>
  );
};
